import React, { Component } from 'react'
import moment from 'moment-timezone'

import Avatar from 'shared-web/src/components/Avatar'

import { getMapURL } from 'app/api/MapAPI'
import CancelAndSave from 'components/customer/CompanyCard/CancelAndSave'

import getGradient from './getGradient'

import colors from 'styles/colors'

export default class Banner extends Component {
  getTime() {
    const { timeZone } = this.props
    return !!timeZone && moment().tz(timeZone)
  }

  getDisplayTime() {
    const time = this.getTime()
    return !!time && time.format('h:mm A z')
  }

  renderLinks() {
    const {
      editing,
      editable,
      handleEdit,
      handleSave,
      handleCancel,
      changed,
      updating,
    } = this.props
    if (editable) {
      return editing
        ? <CancelAndSave
            updating={updating}
            changed={changed}
            onCancel={handleCancel}
            onSave={handleSave}
          />
        : <div className="edit link dsg-Body" onClick={handleEdit}>Edit</div>
    }
  }

  render() {
    const {
      editing,
      longitude,
      latitude,
      displayLocation,
      handleEdit,
      editable,
      endUser, // purely for Avatar!
    } = this.props
    const [leftColor, rightColor] = getGradient(this.getTime(), .8)
    return (
      <div
        className="banner"
        style={{
          height: editing ? '75px' : '85px',
          backgroundImage: longitude && latitude ? `url(${getMapURL(latitude, longitude, 320, 120)})` : undefined,
          borderBottom: `2px solid ${colors['color-navy-light']}`,
          borderTopLeftRadius: '3px',
          borderTopRightRadius: '3px',
          transition: 'all .4s ease-in-out',
        }}
      >
        <div
          className="flex-column"
          style={{
            justifyContent: 'space-around',
            alignItems: 'flex-end',
            height: '100%',
            width: '100%',
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            backgroundImage: `linear-gradient(to right, ${leftColor}, ${rightColor})`,
            paddingRight: '24px',
            position: 'relative',
          }}
        >
          {this.renderLinks()}
          {!editing &&
            <div style={{ paddingBottom: '7px' }}>
              <span className="dsg-Body color-white flex-end dsg-medium-weight">{this.getDisplayTime()}</span>
              <span
                className="dsg-Regular color-white flex-end dsg-medium-weight"
                onClick={editable && !displayLocation && handleEdit}
              >
                {displayLocation || (editable && 'Add Location')}
              </span>
            </div>}
          <Avatar
            user={endUser}
            size="extra-large"
            style={{
              position: 'absolute',
              top: editing ? '12px' : '65px',
              left: '14px',
              transition: 'all .4s ease-out',
            }}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TitleCard/Banner.js